import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { getLoginJwt, setLoginToken } from 'uniba-volto-jwtsession/actions';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';


function LoginJWTViewlet({ toastify }) {
    const dispatch = useDispatch();
    const user_id = useSelector((state) =>
        state.userSession.token ? jwtDecode(state.userSession.token).sub : null,
    );
    const user_token = useSelector((state) => state.userSession?.token);
    const jwtResult = useSelector((state) => state.loginJwt?.result);
    const [shownToast, setShownToast] = React.useState(false);

    // Richiesta JWT se non loggato
    React.useEffect(() => {
        let isMounted = true;
        setShownToast(false);

        if (!user_id) {
            dispatch(getLoginJwt());
        }

        return () => {
            isMounted = false;
        };
    }, [dispatch, user_id]);

    // Quando arriva il token dal reducer loginJwts
    React.useEffect(() => {
        // Esci subito se non c'è jwtResult o se l'utente è già loggato
        if (!jwtResult || user_token) return;

        const token = jwtResult.token;

        // Esci se token non è presente o non è valido
        if (!token || typeof token !== 'string') {
            console.error('Token non valido:', token);
            return;
        }

        // decodifica il JWT
        let decoded;
        try {
            decoded = jwtDecode(token); 
        } catch (e) {
            console.error('Errore decoding JWT:', e);
            return;
        }
        // estrai il userId
        const userId = decoded?.sub || 'utente';

        // Aggiorna lo store
        dispatch(setLoginToken(token));

        // Mostra toast una sola volta
        if (!shownToast && toastify) {
            toastify.toast.success(`Sei loggato come ${userId}!`);
            setShownToast(true);
        }

    }, [jwtResult, user_token, dispatch, toastify, shownToast]);
    return null;
};

export default injectLazyLibs(['toastify'])(LoginJWTViewlet);